module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/c09a24b9f522a62aafc78f9685f97a98.png";